import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Loading } from "@/components/common";
import CreatorDashboard from "@/components/dashboards/CreatorDashboard";
import FreelancerDashboard from "@/components/dashboards/FreelancerDashboard";
import BothDashboard from "@/components/dashboards/BothDashboard";
import ReportsSummaryCard from "@/components/reports/ReportsSummaryCard";

export default function Dashboard() {
  const [d, setD] = useState(null);
  const { user } = useAuth();

  const load = () => api.get("/dashboard").then((r) => setD(r.data));
  useEffect(() => { load(); }, []);

  if (!d) return <Loading label="Carregando painel..." />;

  const t = user?.user_type;
  return (
    <div className="space-y-6">
      <ReportsSummaryCard />
      {t === "creator" ? <CreatorDashboard d={d} reload={load} />
        : t === "both" ? <BothDashboard d={d} reload={load} />
          : <FreelancerDashboard d={d} reload={load} />}
    </div>
  );
}
